// import commonTableColumns from '@root/components/table/commonTableColumns';
import CountTooltip from '@root/components/Tooltip/CountTooltip';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { VulnerabilityCounts } from '../VulnerabilityCounts';

export const imageColumns = [
  {
    field: 'name',
    headerName: 'Image',
    width: 230,
    renderCell: params => {
      return (
        <Tooltip title={params.row?.name}>
          <Text fontWeight={500} className="SingleLine">
            {params.row?.name}
          </Text>
        </Tooltip>
      );
    },
  },

  {
    field: 'related_workloads',
    headerName: 'Workloads',
    renderCell: params => {
      return <CountTooltip labels={params?.row?.related_workloads?.map(item => item.workload_id)} />;
    },
    width: 450,
  },
  {
    field: 'cluster',
    headerName: 'Cluster',
    width: 230,
  },
  {
    field: 'vulnerabilities',
    headerName: 'Vulnerabilities',
    width: 300,
    renderCell: params => {
      return params?.row?.vulnerability_counts ? (
        <VulnerabilityCounts vulnerabilities={params.row.vulnerability_counts} />
      ) : (
        '-'
      );
    },
  },
];
